import { permissionsMappings } from '@lmt/unicorn-shared/app/api/auth/token-decoder';

interface DependentsPermissionsPair {
  mainPermission: string;
  dependentPermission: string;
}

export const permissionDependencies: DependentsPermissionsPair[] = [
  {
    mainPermission: permissionsMappings.dictionariesManagement,
    dependentPermission: permissionsMappings.deleteDictionaries,
  },
  {
    mainPermission: permissionsMappings.userManagement,
    dependentPermission: permissionsMappings.resetPassword,
  },
  {
    mainPermission: permissionsMappings.importMeasurements,
    dependentPermission: permissionsMappings.manualMeasurementImporting,
  },
  {
    mainPermission: permissionsMappings.editMeasurementMappings,
    dependentPermission: permissionsMappings.reImportAllMeasurements,
  },
  {
    mainPermission: permissionsMappings.tenantSettingsChange,
    dependentPermission: permissionsMappings.passwordValidationSettings,
  },
];
